export default "__VITE_ASSET__l2mEoCeR__"